export function compressImage(file, callback, maxSizeKB = 1000, quality = 0.7) {
  if (!file || !(file instanceof File)) return;
  const reader = new FileReader();

  reader.onload = function (event) {
    const img = new Image();
    img.onload = function () {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");


      const MAX_WIDTH = 1200;
      let { width, height } = img;

      if (width > MAX_WIDTH) {
        height = (height * MAX_WIDTH) / width;
        width = MAX_WIDTH;
      }

      canvas.width = width;
      canvas.height = height;

      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob(
        (blob) => {
          if (!blob) return callback(file);

          const newFile = new File([blob], file.name, { type: file.type });
          if (blob.size > maxSizeKB * 1024 && quality > 0.3) {
            compressImage(file, callback, maxSizeKB, quality - 0.1);
          } else {
            callback(newFile);
          }
        },
        file.type,
        quality
      );
    };

    img.src = event.target.result;
  };

  reader.readAsDataURL(file);
}